<template>
  <svg 
    width="14px" 
    height="14px" 
    viewBox="0 0 12 12" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <defs />
    
    <g
      id="Modal"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="01_mobile-views"
        transform="translate(-834.000000, -94.000000)"
        fill="#FFFFFF"
      >
        <g
          id="close"
          transform="translate(820.000000, 80.000000)"
        >
          <g
            id="x-cancel-icon"
            transform="translate(14.000000, 14.000000)"
          >
            <g id="x">
              <path
                id="Combined-Shape"
                d="M6,4.58578644 L1.70710678,0.292893219 L0.292893219,1.70710678 L4.58578644,6 L0.292893219,10.2928932 L1.70710678,11.7071068 L6,7.41421356 L10.2928932,11.7071068 L11.7071068,10.2928932 L7.41421356,6 L11.7071068,1.70710678 L10.2928932,0.292893219 L6,4.58578644 Z"
                :fill="fill"
                fill-rule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      required: true
    }
  }
}
</script>

